<template>
  <div class="document-content">
    <div v-for="(section, index) in sections" :key="index" class="content-section">
      <h2>{{ section.title }}</h2>
      <template v-for="(block, blockIndex) in section.blocks" :key="blockIndex">
        <p v-if="block.p">{{ block.p }}</p>
        <p v-else-if="block.note" class="note">{{ block.note }}</p>
        <h3 v-else-if="block.h3">{{ block.h3 }}</h3>
        <h4 v-else-if="block.h4">{{ block.h4 }}</h4>
        <p v-else-if="block.strong"><strong>{{ block.strong }}</strong></p>
        <ul v-else-if="block.ul">
          <li v-for="(item, itemIndex) in block.ul" :key="itemIndex">{{ item }}</li>
        </ul>
        <div v-else-if="block.cards" class="data-categories">
          <div v-for="(card, cardIndex) in block.cards" :key="cardIndex" class="category-item">
            <h3>{{ card.title }}</h3>
            <ul>
              <li v-for="(item, itemIndex) in card.items" :key="itemIndex">{{ item }}</li>
            </ul>
          </div>
        </div>
        <div v-else-if="block.pairs" class="legal-bases">
          <div v-for="(pair, pairIndex) in block.pairs" :key="pairIndex" class="basis-item">
            <strong>{{ pair.title }}</strong>
            <p>{{ pair.text }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { LegalSection } from '@/content/legal/types'

defineProps<{
  sections: LegalSection[]
}>()
</script>

<style scoped>
.document-content { line-height: 1.7; }
.content-section { margin-bottom: 2.5rem; }
.content-section h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--primary-blue);
}
.content-section h3 { margin: 0 0 0.75rem; color: var(--text-primary); }
.content-section h4 { margin: 0.5rem 0; color: var(--text-primary); }
.content-section p,
.note {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0 0 1rem;
}
.content-section ul { margin: 1rem 0; padding-left: 1.5rem; }
.content-section li { margin-bottom: 0.5rem; color: var(--text-secondary); }
.data-categories, .legal-bases { display: grid; gap: 1rem; }
.category-item, .basis-item {
  padding: 1rem;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md, 8px);
  background: var(--background-secondary);
}
.basis-item strong { display: block; margin-bottom: 0.35rem; color: var(--text-primary); }
</style>
